import { useState } from 'react';
import { SIGNUP_SLUG_KEY } from './signupHelpers';

/**
 * §1bis (decisión de Arturo 08/10) — el slug ya no se pide en el alta: lo genera el backend
 * del nombre del negocio, y el login lo sigue pidiendo. Tras el alta se muestra UNA vez el
 * identificador con que se entra (también va en el correo de confirmación, con una liga que
 * lo trae escrito, y queda prellenado en este navegador).
 */
export function SignupIdentifierNotice() {
  const [slug, setSlug] = useState<string | null>(() => {
    try { return sessionStorage.getItem(SIGNUP_SLUG_KEY); } catch { return null; }
  });
  if (!slug) return null;
  const dismiss = () => {
    try { sessionStorage.removeItem(SIGNUP_SLUG_KEY); } catch { /* sin storage */ }
    setSlug(null);
  };
  return (
    <div className="border-b border-emerald-200 bg-emerald-50 text-emerald-900">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-2 px-4 py-2 text-xs md:px-6">
        <span>
          Tu identificador para entrar: <strong className="font-mono text-sm">{slug}</strong>. Guárdalo: lo
          necesitas junto con tu correo para iniciar sesión (también te lo enviamos por correo).
        </span>
        <button type="button" onClick={dismiss}
          className="rounded-md bg-white/70 px-3 py-1 text-[11px] font-medium text-emerald-900 hover:bg-white">
          Entendido
        </button>
      </div>
    </div>
  );
}
